/**
 * Does an option label match what was typed into a search box?
 *
 * Every typed word must appear somewhere in the label, in any order, so
 * "Daniel Lee", "lee daniel" and "Lee, Daniel" all find "Daniel Lee · CH-12".
 * Anything the old whole-phrase match found still matches (each word of a
 * phrase the label contains is also in the label); case is ignored.
 *
 * @param {string} label option label
 * @param {string} term what the user typed
 * @returns {boolean}
 */
export function labelMatchesSearch(label, term) {
  const haystack = String(label ?? '').toLowerCase();
  const words = String(term ?? '').toLowerCase().split(/[\s,]+/).filter(Boolean);
  return words.every((word) => haystack.includes(word));
}

export default labelMatchesSearch;
